const keys = ['opinionTypeFilter', 'opinionTypeAgainst', 'opinionTypeNeutral', 'opinionTypeFor', 'opinionTypesEmpty'];

const copy = {
  en: ['Opinion types', 'Against (1–3)', 'Neutral (4)', 'For (5–7)', 'No opinions of the selected types.'],
  ru: ['Типы мнений', 'Против (1–3)', 'Нейтрально (4)', 'За (5–7)', 'Мнений выбранных типов нет.'],
  es: ['Tipos de opinión', 'En contra (1–3)', 'Neutral (4)', 'A favor (5–7)', 'No hay opiniones de los tipos seleccionados.'],
  fr: ['Types d’opinions', 'Contre (1–3)', 'Neutre (4)', 'Pour (5–7)', 'Aucune opinion des types sélectionnés.'],
  de: ['Meinungstypen', 'Dagegen (1–3)', 'Neutral (4)', 'Dafür (5–7)', 'Keine Meinungen der ausgewählten Typen.'],
  it: ['Tipi di opinione', 'Contrario (1–3)', 'Neutrale (4)', 'Favorevole (5–7)', 'Nessuna opinione dei tipi selezionati.'],
  pt: ['Tipos de opinião', 'Contra (1–3)', 'Neutro (4)', 'A favor (5–7)', 'Não há opiniões dos tipos selecionados.'],
  tr: ['Görüş türleri', 'Karşı (1–3)', 'Tarafsız (4)', 'Destekleyen (5–7)', 'Seçilen türlerde görüş yok.'],
  ja: ['意見の種類', '反対（1–3）', '中立（4）', '賛成（5–7）', '選択した種類の意見はありません。'],
  ko: ['의견 유형', '반대 (1–3)', '중립 (4)', '찬성 (5–7)', '선택한 유형의 의견이 없습니다.'],
  zh: ['观点类型', '反对（1–3）', '中立（4）', '支持（5–7）', '没有所选类型的观点。'],
  hi: ['राय के प्रकार', 'विरोध में (1–3)', 'तटस्थ (4)', 'पक्ष में (5–7)', 'चुने गए प्रकारों की कोई राय नहीं है।'],
};

export default Object.fromEntries(Object.entries(copy).map(([language, values]) => [
  language, Object.fromEntries(keys.map((key, index) => [key, values[index]])),
]));
